import { ReloadOutlined } from '@ant-design/icons';
import { Alert, Button, Card } from 'antd';
import { useSuggestPromptsMutation } from 'api/MessageAiApi';
import { MessageTypeEnum } from 'api/MessagesApi';
import SpinComponent from 'components/Tool/SpinComponent/SpinComponent';
import { BsStars } from 'react-icons/bs';
import './AiSuggestPrompts.css';

type AllProps = {
  type: MessageTypeEnum;
  tones: string[];
  recipientName: string;
  recipientRelationship?: string;
  eventType: string;
  slot: string;
  onSelect?: (text: string) => void;
};

function AiSuggestPrompts({
  type,
  tones,
  recipientName,
  recipientRelationship,
  eventType,
  slot = 'general',
  onSelect
}: AllProps) {
  const [suggestPrompts, { data, isLoading, error }] = useSuggestPromptsMutation();

  const handleGenerate = async () => {
    await suggestPrompts({
      type,
      tones,
      recipientName,
      recipientRelationship,
      eventType,
      slot,
      initialInput: data?.question
    });
  };

  return (
    <div className="generate-prompts-section">
      {error && (
        <Alert
          message="Couldn't load suggestions"
          description="Please try again or continue without suggestions."
          type="warning"
          style={{ marginTop: '12px' }}
          closable
        />
      )}

      <SpinComponent isLoading={isLoading}>
        {data ? (
          <Card className="prompt-suggestions-card" size="small">
            <div className="question-block">{data.question}</div>

            <div className="sentence-hint">Start with something like:</div>
            <ul className="sentence-list">
              {data.sentences.map((sentence) => (
                <li key={sentence} className="sentence-item" onClick={() => onSelect?.(sentence)}>
                  {sentence}
                </li>
              ))}
            </ul>

            <Button type="link" onClick={handleGenerate} icon={<ReloadOutlined />}>
              Different prompt
            </Button>
          </Card>
        ) : (
          <div className="text-center">
            <Button icon={<BsStars />} onClick={handleGenerate}>
              Get inspiration
            </Button>
          </div>
        )}
      </SpinComponent>
    </div>
  );
}

export default AiSuggestPrompts;
